<template>
<!--Redesign nach Anforderungen-->
  <div class="success">

    <div class="success-title">
      <h2>Vielen Dank! Wir haben Ihren Auftrag erhalten.</h2>
      <p>
        Sie erhalten in Kürze per E-Mail eine Bestätigung über den Eingang des Auftrags.
      </p>
    </div>

    <div
        class="form-buttons nav-control success-buttons"
        id="button-wrapper"
      >
        <button
          type="button"
          class="btn btn-outline-secondary mt-3 shadow-none"
          id="backwards-button"
        >
          <router-link class="btn mb-3 btn" :to="{ name: 'Diagnosis' }" style="margin-bottom: 0px !important">
            Weiterer Auftrag
          </router-link>
        </button>

        <span>
          <button
            type="submit"
            class="btn btn-primary mt-3 shadow-none"
            id="submit-button"
          >
           <a href="https://christ.de" class="btn mb-3 btn" style="margin-bottom: 0px !important"
              >Zum CHRIST Shop</a
            >
          </button>
        </span>
        
      </div>

    <div class="form-process-wrapper">
        <hr class="my-4" />
        <div class="form-mobile mobile-steps">
          <div class="footer-accordion">
           <b-card no-body class="mb-1" v-for="info in infoText" :key="info.id">
              <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle="'info' + info.id" variant="info" class="form-footer-btn">
                      <img v-if="info.id === 1"
                        src="@/assets/images/overview/1.svg"
                        alt="Fertig"
                        style="width: 20px; height: 20px;"
                      >
                      <img v-if="info.id === 2"
                        src="@/assets/images/overview/2.svg"
                        alt="Schritt 2"
                      >
                      <img v-if="info.id === 3"
                        src="@/assets/images/overview/3.svg"
                        alt="Schritt 3"
                      >
                      <span>{{info.title}}</span>
                      <img src="@/assets/images/help-center/down.svg" class="accordion-icon" alt="Down Icon" />
                  </b-button>
              </b-card-header>
              <b-collapse :id="'info' + info.id" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                      {{info.text}}
                  </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
        <div class="form-tablet">
          <div class="form-footer-row">
            <div v-for="info in infoText.slice(0,2)" :key="info.id" class="form-footer-steps">
              <div class="form-footer-steps-title">
                <img v-if="info.id === 1"
                  src="@/assets/images/overview/1.svg"
                  alt="Fertig"
                >
                <img v-if="info.id === 2"
                  src="@/assets/images/overview/2.svg"
                  alt="Schritt 2"
                >
                <p>{{info.title}}</p>
              </div>
              <span>{{info.text}}</span>
            </div>
          </div>
          <hr class="my-4" />
          <div class="form-footer-row">
            <div v-for="info in infoText.slice(2)" :key="info.id" class="form-footer-steps">
              <div class="form-footer-steps-title">
                <img v-if="info.id === 3"
                  src="@/assets/images/overview/3.svg"
                  alt="Schritt 3"
                >
                <p>{{info.title}}</p>
              </div> 
              <span>{{info.text}}</span>
            </div>
          </div>
           
        </div>
        <div class="form-desktop">
          <div class="form-footer-row">
            <div v-for="info in infoText" :key="info.id" class="form-footer-steps">
              <div class="form-footer-steps-title">
                <img v-if="info.id === 1"
                  src="@/assets/images/overview/1.svg"
                  alt="Fertig"
                >
                <img v-if="info.id === 2"
                  src="@/assets/images/overview/2.svg"
                  alt="Schritt 2"
                >
                <img v-if="info.id === 3"
                  src="@/assets/images/overview/3.svg"
                  alt="Schritt 3"
                >
                <p>{{info.title}}</p>
              </div>
              <span>{{info.text}}</span>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Success",
  data() {
    return {
      totalSteps: this.$router.options.routes[
        this.$router.options.routes.length - 1
      ].children.length,
      infoText: [
        {id: 1, title: "Service-Leistung erfassen", text: "Unser System ermittelt basierend auf Ihren Antworten die notwendigen Service-Leistungen. \n\nBei Rückfragen zum Schaden werden wir mit Ihnen Kontakt aufnehmen."},
        {id: 2, title: "Versand", text: "Sie versenden den Artikel an die CHRIST-Service-Werkstatt in einem geeigneten Paket (kein Luftpolsterumschlag). Sobald das Paket bei uns angekommen ist, bestätigen wir Ihnen den Erhalt per E-Mail."},
        {id: 3, title: "Reparatur/Anfertigung/Umarbeitung", text: "Nach abgeschlossener Reparatur/Anfertigung/Umarbeitung erfolgt der kostenfreie Rückversand des Artikels, sowie der Rechnung an die von Ihnen angegebene Adresse." +
          "\nBei Unklarheiten oder Preisabweichungen nehmen wir direkt Kontakt mit Ihnen auf und Sie erhalten einen verbindlichen Kostenvoranschlag."}
      ]
    };
  },
  computed: {
    currentStep() {
      return this.$store.state.currentStep;
    }
  },
  mounted() {
    this.$store.commit(
      "setTotalSteps",
      this.$router.options.routes[this.$router.options.routes.length - 1]
        .children.length
    );
  },
};
</script>
